import {
  addCreateTreatmentPlanV3AssessmentBehaviorCases,
  addDeleteTreatmentPlanV3AssessmentBehaviorCases,
  addUpdateTreatmentPlanV3AssessmentBehaviorCases,
} from './behaviors';
import {
  addCreateTreatmentPlanV3AssessmentMethodCases,
  addDeleteTreatmentPlanV3AssessmentMethodCases,
  addUpdateTreatmentPlanV3AssessmentMethodCases,
} from './methods';
import {
  addGetTreatmentPlanV3AssessmentPageCases,
  addGetTreatmentPlanV3AssessmentTemplatesCases,
  addUpdateTreatmentPlanV3AssessmentPageCases,
} from './page';
import { addUpdateTreatmentPlanV3AssessmentReadinessItemCases } from './readiness';
import {
  addCreateTreatmentPlanV3AssessmentMethodVisualsCases,
  addDeleteTreatmentPlanV3AssessmentMethodVisualCases,
  addUpdateTreatmentPlanV3AssessmentMethodVisualCases,
  addUpdateTreatmentPlanV3AssessmentMethodVisualFileCases,
} from './visuals';

import type { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import type { TreatmentPlanV3State } from '../../../types';
import type { TreatmentPlanV3AssessmentThunks } from '../types';

export function addTreatmentPlanV3AssessmentCases(
  builder: ActionReducerMapBuilder<TreatmentPlanV3State>,
  thunks: TreatmentPlanV3AssessmentThunks,
) {
  addGetTreatmentPlanV3AssessmentPageCases(builder, thunks);
  addGetTreatmentPlanV3AssessmentTemplatesCases(builder, thunks);
  addUpdateTreatmentPlanV3AssessmentPageCases(builder, thunks);
  addCreateTreatmentPlanV3AssessmentBehaviorCases(builder, thunks);
  addUpdateTreatmentPlanV3AssessmentBehaviorCases(builder, thunks);
  addDeleteTreatmentPlanV3AssessmentBehaviorCases(builder, thunks);
  addCreateTreatmentPlanV3AssessmentMethodCases(builder, thunks);
  addUpdateTreatmentPlanV3AssessmentMethodCases(builder, thunks);
  addDeleteTreatmentPlanV3AssessmentMethodCases(builder, thunks);
  addUpdateTreatmentPlanV3AssessmentReadinessItemCases(builder, thunks);
  addCreateTreatmentPlanV3AssessmentMethodVisualsCases(builder, thunks);
  addUpdateTreatmentPlanV3AssessmentMethodVisualCases(builder, thunks);
  addUpdateTreatmentPlanV3AssessmentMethodVisualFileCases(builder, thunks);
  addDeleteTreatmentPlanV3AssessmentMethodVisualCases(builder, thunks);
}
